import React from 'react'
import { Container, Texto } from './Styled'
import logoCNU2025 from 'images/pos-cnu-2025/logo-pos-cnu-2025.png'

export default function TextoFinal () {

	return (
		<Container>

			{/* Texto */}
			<Texto>Não é à toa que 70% dos aprovados estudam com o Estratégia — e grande parte deles só chegou lá porque usou as ferramentas da Assinatura Premium.</Texto>

			{/* Texto */}
			<Texto>Você também pode aproveitar esses recursos agora, com os mesmos 30 dias de garantia que já conhece.</Texto>

			{/* Texto */}
			<Texto>Mas atenção: essa condição especial vai sair da sua área do aluno em pouco tempo.</Texto>

			{/* Texto */}
			<Texto>Queremos ver o seu nome na lista de aprovados!</Texto>

		</Container>
	)
}
